'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonGroup = require('../ButtonGroup');

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      color = _ref.color,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === undefined ? 'primary' : _ref$activeColor,
      value = _ref.value,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties3.default)(_ref, ['options', 'color', 'activeColor', 'value', 'onChange']);
  return _react2.default.createElement(
    _ButtonGroup2.default,
    props,
    options.map(function (option) {
      return _react2.default.createElement(_Button2.default, (0, _extends3.default)({}, option, {
        key: option.value,
        label: option.label,
        onClick: function onClick() {
          return onChange(option.value);
        },
        color: value == option.value ? option.activeColor || activeColor : option.color || color
      }));
    })
  );
};

exports.default = RadioButtonGroup;